import { Box, Typography } from '@mui/material'
import { FC, useId } from 'react'

export interface Detail {
  /** Stable key; also names the value's test id (`<testIdPrefix>-<key>`). */
  key: string
  label: string
  /** null shows '—'. */
  value: string | null
}

/** Labelled values in a grid; each value is named by its label. */
export const DetailList: FC<{ details: Detail[]; testIdPrefix?: string; columns?: number }> = ({ details, testIdPrefix, columns = 4 }) => {
  const id = useId()
  return (
    <Box
      component="dl"
      m={0}
      display="grid"
      gap={2}
      sx={{ gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: `repeat(${String(columns)}, 1fr)` } }}
    >
      {details.map(({ key, label, value }) => (
        <Box key={key}>
          <Typography component="dt" variant="caption" color="text.secondary" id={`${id}-${key}`}>
            {label}
          </Typography>
          <Typography
            component="dd"
            m={0}
            fontWeight="medium"
            aria-labelledby={`${id}-${key}`}
            data-testid={testIdPrefix && `${testIdPrefix}-${key}`}
          >
            {value ?? '—'}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}
